import { Routing } from "@common/_constants";

import { ErrorService } from "./error.service";
import { refetch } from "./refetch";

export const LocationService = {
    suggestLocations,
};

function suggestLocations(
    term: string,
    includeAny: boolean,
    includeRemote: boolean,
    abortSignal: AbortSignal
) {
    const url =
        Routing.Api.General.Locations.SUGGEST +
        `?query=${term}&includeAny=${includeAny}&includeRemote=${includeRemote}`;
    const settings = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        signal: abortSignal,
    };
    return refetch(url, settings, false).then(unwrapResult);
}

// helpers...
// TODO: This may be useful for all services.
function unwrapResult(resp) {
    return ErrorService.handleErrors(resp)
        .then(response => response.json())
        .then(json => json.result);
}
